export default {
  ADD_QUOTE(state, payload) {
    state.quote.result.unshift(payload);
    state.quote.totalCount += 1;
  },
  getQuoteData(state, payload) {
    state.quote = payload;
  },
  EDIT_MANTRA(state, payload) {
    let index = state.quote.result.findIndex((x) => x._id == payload._id);
    state.quote.result.splice(index, 1, payload);
  },
  DELETE_QUOTE(state, payload) {
    let index = state.quote.result.findIndex((x) => x._id == payload._id);
    state.quote.result.splice(index, 1);
    state.quote.totalCount -= 1;
  },
};
